/**
 * Canonical anomaly severity palette — matches App.css priority classes used on the home page:
 * .text-Critical, .text-High, .text-Medium, .text-Low
 */
export const ANOMALY_SEVERITY_COLORS = {
  CRITICAL: "#f14738",
  HIGH:     "#f99c35",
  MEDIUM:   "#00bc07",
  LOW:      "#0063b8",
};

export const ANOMALY_SEVERITY_BADGE = {
  CRITICAL: "badge-Critical",
  HIGH:     "badge-High",
  MEDIUM:   "badge-Medium",
  LOW:      "badge-Low",
};

export const ANOMALY_SEVERITY_TEXT_CLASS = {
  CRITICAL: "text-Critical",
  HIGH:     "text-High",
  MEDIUM:   "text-Medium",
  LOW:      "text-Low",
};

export const ANOMALY_SEVERITY_ORDER = ["CRITICAL", "HIGH", "MEDIUM", "LOW"];

export const ANOMALY_SEVERITY_ORDER_WEIGHT = {
  CRITICAL: 4,
  HIGH:     3,
  MEDIUM:   2,
  LOW:      1,
};

export const ANOMALY_SEVERITY_MARKER = {
  CRITICAL: { color: ANOMALY_SEVERITY_COLORS.CRITICAL, radius: 10, pointStyle: "circle",  hollow: false },
  HIGH:     { color: ANOMALY_SEVERITY_COLORS.HIGH,     radius: 9,  pointStyle: "triangle", hollow: false },
  MEDIUM:   { color: ANOMALY_SEVERITY_COLORS.MEDIUM,   radius: 8,  pointStyle: "rectRot",  hollow: false },
  LOW:      { color: ANOMALY_SEVERITY_COLORS.LOW,      radius: 6,  pointStyle: "circle",  hollow: true  },
};

export const ANOMALY_SEVERITY_LEGEND = [
  { key: "CRITICAL", markerClass: "legend-critical" },
  { key: "HIGH",     markerClass: "legend-high" },
  { key: "MEDIUM",   markerClass: "legend-medium" },
  { key: "LOW",      markerClass: "legend-low" },
];

/** Home page AnomalySummaryHome severity legend items */
export const ANOMALY_SEVERITY_HOME_ITEMS = [
  { key: "CRITICAL", className: ANOMALY_SEVERITY_TEXT_CLASS.CRITICAL, labelKey: "AnomalyDetection.critical.label" },
  { key: "HIGH",     className: ANOMALY_SEVERITY_TEXT_CLASS.HIGH,     labelKey: "AnomalyDetection.high.label" },
  { key: "MEDIUM",   className: ANOMALY_SEVERITY_TEXT_CLASS.MEDIUM,   labelKey: "AnomalyDetection.medium.label" },
  { key: "LOW",      className: ANOMALY_SEVERITY_TEXT_CLASS.LOW,      labelKey: "AnomalyDetection.low.label" },
];

export const getAnomalySeverityColor = (severity) =>
  ANOMALY_SEVERITY_COLORS[severity] || "#94a3b8";

/** Display label: first letter uppercase, remainder lowercase (e.g. CRITICAL → Critical). */
const formatAnomalyEnumLabel = (value) => {
  if (value == null || value === "") return "";
  const str = String(value);
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const formatAnomalySeverityLabel = formatAnomalyEnumLabel;
export const formatAnomalyStatusLabel = formatAnomalyEnumLabel;

export const compareAnomalySeverity = (a, b) =>
  (ANOMALY_SEVERITY_ORDER_WEIGHT[a] || 0) - (ANOMALY_SEVERITY_ORDER_WEIGHT[b] || 0);
